export default class {
  constructor(el) {
    this.dom = {el: el};
    this.dom.closer = this.dom.el.querySelector('[data-js="closer"]');
    this.dom.viewTrigger = (document.querySelector('.g-banners')) ? document.querySelector('.g-banners') : document.querySelector('.st-footer');

    this.close = this.close.bind(this);

    this.io = null;
    this.checkScroll = this.checkScroll.bind(this);

    this.init();
  }

  init() {
    const _this = this;

    this.dom.closer.addEventListener('click', this.close);

    // IO
    const ioOptions = {
      threshold: 0.25,
    };
    this.io = new IntersectionObserver(this.checkScroll, ioOptions);
    this.io.observe(this.dom.viewTrigger);
  }

  close() {
    this.dom.el.dataset.close = true;
  }

  hidden() {
    this.dom.el.dataset.is = 'hidden';
  }

  show() {
    this.dom.el.dataset.is = 'show';
  }

  checkScroll(entries) {
    for (let i = 0, l = entries.length; i < l; i++) {
      const e = entries[i];
      if (e.intersectionRatio > 0.25) {
        this.hidden();
      } else {
        this.show();
      }
    }
  }
}
